import React from "react";

export default function Footer() {
  return (
    <footer className="footer flex full-width">
      <p>© 2020 Paul Dickerson</p>
    </footer>
  );
}
